import { cva, VariantProps } from 'class-variance-authority';
import { cn } from '@/components/ui/utils';

const styles = cva('bg-background border border-border rounded overflow-y-clip', {
  variants: {},
  defaultVariants: {},
});

export type TappTableWrapperProps = {} & VariantProps<typeof styles> & React.ComponentProps<"section">;

export const TappTableWrapper: React.FC<TappTableWrapperProps> = ({ children, className, ...props }) => {
  // console.log(children);
  // const table =
  //   children instanceof Array
  //     ? children.find((node) => node?.type?.name === 'TappTable')
  //     : (children as any)?.type?.node === 'TappTable'
  //     ? children
  //     : null;

  return <section className={cn(styles({}), className)}>{children}</section>;
};
